import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export enum AppThemes {
	dark = 'dark-theme',
	light = 'ead-theme',
}

@Injectable({
	providedIn: 'root',
})
export class ThemeService {
	currentTheme: AppThemes | undefined;
	currentThemeSubject = new Subject<string>();

	toggleTheme(): void {
		if (this.currentTheme === AppThemes.light) {
			this.currentTheme = AppThemes.dark;
			this.currentThemeSubject.next(AppThemes.dark);
		} else {
			this.currentTheme = AppThemes.light;
			this.currentThemeSubject.next(AppThemes.light);
		}
	}

	getTheme(): Observable<string> {
		return this.currentThemeSubject.asObservable();
	}

	setTheme(type: string) {
		if (type === 'dark') {
			this.currentTheme = AppThemes.dark;
			this.currentThemeSubject.next(AppThemes.dark);
		} else if (type === 'light') {
			this.currentTheme = AppThemes.light;
			this.currentThemeSubject.next(AppThemes.light);
		}
	}

	getThemeAsString(): string {
		if (this.currentTheme === AppThemes.light) {
			return 'light';
		}
		return 'dark';
	}

	getPrimaryColorFromCssVar() {
		const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--color-primary');
		const trimmedRgb = primaryColor.replace(/\s/g, '');
		const rgb = 'rgb(' + trimmedRgb + ')';
		return this.rgbToHex(rgb);
	}

	rgbToHex(rgb) {
		const rgbRegex = /^rgb\(\s*(-?\d+)(%?)\s*,\s*(-?\d+)(%?)\s*,\s*(-?\d+)(%?)\s*\)$/;
		let result,
			r,
			g,
			b,
			hex = '';
		if ((result = rgbRegex.exec(rgb))) {
			r = this.componentFromStr(result[1], result[2]);
			g = this.componentFromStr(result[3], result[4]);
			b = this.componentFromStr(result[5], result[6]);

			hex = '#' + (0x1000000 + (r << 16) + (g << 8) + b).toString(16).slice(1);
		}
		return hex;
	}

	private componentFromStr(numStr, percent) {
		const num = Math.max(0, parseInt(numStr, 10));
		return percent ? Math.floor((255 * Math.min(100, num)) / 100) : Math.min(255, num);
	}
}
